<div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <div class="sidebar-header">
        <a [routerLink]="['/']" class="logo flex justify-content-center">
            
            <span class="app-name text-xs my-3">WISE INSURANCE</span>
        </a>
        <button class="layout-sidebar-anchor p-link" type="button" (click)="anchor()"></button>
    </div>

    <div #menuContainer  class="layout-menu-container">
        <app-menu></app-menu>
    </div>
</div>
